/* field: salesPeople -> results */
export const SALES_PERSON_FRAGMENT = `
  fragment SalesPersonParts on SalesPerson {
    id
    name
    code
  }
`
/* field: customerSearch -> results */
export const CUSTOMER_LIST_FRAGMENT = `
  fragment CustomerListParts on Customer {
    id
    petraId
    firstName
    middleName
    lastName
    ssnitNumber
    fullname
    customerEmails {
      id
      email {
        id
        address
      }
      isPrimary
      isActive
    }
    activeCustomerPhones {
      id
      phone {
        id
        number
        type
      }
      isPrimary
      isActive
    }
  }
`

/* field: customerPayoutAccounts */
export const CUSTOMER_PAYOUT_ACCOUNT_FRAGMENTS = `
  fragment CustomerPayoutAccountParts on CustomerPayoutAccount {
    id
    accountNumber
    accountType
    institutionName
    name
    isPayoutAccountVerified
    payoutAccountVerifiedAt
    bankBranch {
      id
      name
      financialInstitution {
        id
        name
      }
      sortCode
    }
  }
`